import { createAction } from '@reduxjs/toolkit';

import type {
  EmisoraClassificationData,
  EmisoraClassificationResponse,
} from 'commons/modules/service/emisora';

import { arrayValidation, sortArrayOfAlphaNum } from 'utils/array';

import { createReportSlice } from './reportStore';

const initialFilters = {
  marketType: '',
  instrument: '',
  symbol: '',
  description: '',
  specialOperation: '',
  nationality: '',
};

export const setEmisoraData = createAction<EmisoraClassificationResponse>(
  'operationEmisora/setEmisoraData',
);

const slice = createReportSlice<EmisoraClassificationData>(
  'operationEmisora',
  initialFilters,
  (builder) => {
    builder.addCase(setEmisoraData, (state, action) => {
      const { data, pagination } = action.payload;
      let newData: EmisoraClassificationData[] = [];

      if (arrayValidation(data)) {
        newData = sortArrayOfAlphaNum(data, 'issuer');
      }

      state.data = newData;
      state.total = pagination?.total || 0;
    });
  },
);

export default slice.reducer;
